import { SubscriptionPlan } from "@/constants/plans";
import { Model } from "@/types/models";

import { isModelAvailableForSubscriptionPlan } from "./isModelAvailableForSubscriptionPlan";

/**
 * Daily model lists show plan-included models always; out-of-plan models only when they have score data.
 */
export function shouldShowModelInDailyList(
  model: Pick<Model, "tier">,
  hasScoreData: boolean,
  plan: SubscriptionPlan | null | undefined,
): boolean {
  if (isModelAvailableForSubscriptionPlan(model, plan)) {
    return true;
  }

  return hasScoreData;
}
